import { AxiosResponse } from "axios";

export type InstagramAPIError = AxiosResponse<{
  errors: { field: string; message: string }[];
}>;

export function isInstagramApiError(
  error: unknown
): error is InstagramAPIError {
  if (
    error &&
    typeof error === "object" &&
    "data" in error &&
    typeof (error as AxiosResponse).data === "object"
  ) {
    const { data } = error as AxiosResponse;

    if (
      "errors" in data &&
      Array.isArray(data.errors) &&
      data.errors.every(
        (e: { field: string; message: string }) =>
          typeof e.field === "string" && typeof e.message === "string"
      )
    ) {
      return true;
    }
  }

  return false;
}
